/* @flow */
import AuthActions from 'auth/AuthActions';
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import Columns2 from 'components/Columns2.jsx';
import DialogContent from 'components/DialogContent.jsx';
import enumerate from 'lib/enumerate';
import Image from 'components/Image.jsx';
import JoinOrganizationAvatarPanel from './JoinOrganizationAvatarPanel.jsx';
import JoinOrganizationFormPanel from './JoinOrganizationFormPanel.jsx';
import JoinPageLoadingIndicator from './JoinPageLoadingIndicator.jsx';
import Link from 'components/Link.jsx';
import OrganizationProfile from 'entities/OrganizationProfile';
import React from 'react';
import ResponsiveMixin from 'components/mixins/ResponsiveMixin';
import { Roles } from 'user/UserConstants';
import SchoolPickerModal from 'components/SchoolPickerModal.jsx';
import { mountModal } from 'lib/modal';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

import './styles/JoinOrganizationPage.scss';

const STATUS = enumerate([
  'loading',
  'success',
  'failure',
]);

type State = {
  status: number,
  organization: ?OrganizationProfile,
  query: string,
  light: boolean,
};

const JoinOrganizationPage = React.createClass({
  propTypes: {
    location: React.PropTypes.object.isRequired,
    params: React.PropTypes.object.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    ResponsiveMixin,
  ],

  statics: {
    SMALL: 700,
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      const onSuccess = () => {
        replaceWith(`/school/confirm/${nextState.params.id}`);
        callback();
      };

      AuthActions.checkLoggedIn().then(onSuccess, () => callback());
    },
  },

  // typecheck: ignore statement
  getInitialState(): State {
    return {
      status: STATUS.loading,
      organization: null,
      query: this.props.location.query,
      light: false,
    };
  },

  componentDidMount() {
    this.fetchOrganization();
  },

  componentWillReceiveProps(nextProps: Object) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetchOrganization();
    }
  },

  onChange() {
    const onSchoolSelect = (schoolId) => {
      this.context.router.push(`/school/join/${schoolId}`);
    };

    const onNotTeacher = () => {
      this.context.router.push('/sign_up');
    };

    mountModal(
      <SchoolPickerModal
        onSchoolSelect={onSchoolSelect}
        onNotTeacher={onNotTeacher}
      />
    , this);
  },

  fetchOrganization() {
    const onSuccess = (organization) => {
      this.setState({
        status: STATUS.success,
        organization,
      });
    };

    const onFailure = () => {
      this.setState({ status: STATUS.failure });
    };

    const organizationId = this.props.params.id;

    OrganizationProfile
      .fetch({ id: organizationId })
      .then(onSuccess, onFailure);
  },

  renderFailure() {
    return (
      <CenteredContainer className="JoinOrganizationPage-ErrorPane">
        <BoxBody>
          <Image
            className="NotFoundPage-image"
            src={require('assets/images/emoji-grin.svg')}
            alt="This is embarrassing"
          />
          <div className="NotFoundPage-title">Uh oh! Something went wrong.</div>
          <p>We could not find this school.</p>
        </BoxBody>
      </CenteredContainer>
    );
  },

  renderLoading() {
    return (
      <JoinPageLoadingIndicator />
    );
  },

  renderSuccess() {
    if (this.isComponentSize(JoinOrganizationPage.SMALL)) {
      const subText = (
        <span>
          Not your school?{' '}
          <Link color="thunder" onClick={this.onChange}>
            <strong>
              Change
            </strong>
          </Link>
        </span>
      );

      return (
        <DialogContent
          title={
            // $FlowFixMe
            `Signup for Remind at ${this.state.organization.getName()}`
          }
          subtext={subText}
          full
          size="large"
          onRequestHide={() => {}}
          className="JoinOrganizationPage">
          <Box className="AuthenticationView-box">
            <BoxBody>
              <JoinOrganizationFormPanel
                role={this.state.query.role || Roles.teacher}
                defaultValues={this.state.query}
                organization={this.state.organization}
              />
            </BoxBody>
          </Box>
        </DialogContent>
      );
    }

    return (
      <DialogContent
        size="large"
        full
        onRequestHide={() => {}}
        className="JoinOrganizationPage">
        <Box className="AuthenticationView-box">
          <BoxBody>
            <Columns2>
              <div className="JoinOrganizationPage-LeftPanel">
                <JoinOrganizationAvatarPanel organization={this.state.organization} />
                <span className="JoinOrganizationPage-LeftPanel-Footer">
                  Not your school?{' '}
                  <Link color="thunder" onClick={this.onChange}>
                    <strong>
                      Change
                    </strong>
                  </Link>
                </span>
              </div>
              <JoinOrganizationFormPanel
                role={this.state.query.role || Roles.teacher}
                defaultValues={this.state.query}
                organization={this.state.organization}
              />
            </Columns2>
          </BoxBody>
        </Box>
      </DialogContent>
    );
  },

  render() {
    return {
      [STATUS.loading]: this.renderLoading,
      [STATUS.success]: this.renderSuccess,
      [STATUS.failure]: this.renderFailure,
    }[this.state.status]();
  },
});

export default JoinOrganizationPage;



// WEBPACK FOOTER //
// ./src/join/components/JoinOrganizationPage.jsx